import styled from '@emotion/styled'

import {Box, Flex} from 'src/components/Box'
import * as styles from 'src/styles'
import {ToastMessage} from 'src/context/ToastContext'
import {Lede, Body} from 'src/components/text'

const Emoji = styled.span(({theme}) => ({
  marginLeft: theme.space[1],
}))

const Container = styled(Box)([
  styles.borders.activeBorder,
  styles.shadow.containerShadow,
  ({theme}) => ({
    borderRadius: '0.4rem',
    backgroundColor: theme.colors.white,
    cursor: 'pointer',
  }),
])

const ToastBody = ({heading, emoji, text}: ToastMessage['body']) => (
  <Flex flexDirection="column" alignItems="center">
    {heading && (
      <Lede mb="1">
        {heading}
        {emoji && (
          <Emoji role="img" aria-label={emoji.label}>
            {emoji.emoji}
          </Emoji>
        )}
      </Lede>
    )}
    <Body color={heading ? 'grey5' : undefined}>{text}</Body>
  </Flex>
)

const Toast: React.FunctionComponent<Pick<ToastMessage, 'body' | 'clear'>> = ({
  body,
  clear,
}) => (
  <Container role="alert" p="2" onClick={clear}>
    <ToastBody {...body} />
  </Container>
)

export default Toast
